import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { useGetExistingProjectionsQuery } from '@bo-services/simulationsApi';

export function useSimulationsExistingProjections({
  gameId,
  leagueId,
  allMarkets
}: {
  gameId: string;
  leagueId: string;
  allMarkets: Array<{
    league_id: string;
    market: string;
    market_id: string;
    stat_type_id: number;
  }>;
}): {
  existingProjections: Array<GamePlayerProjectionTrading> | undefined;
  isSimulationExistingProjectionsError: boolean;
  isSimulationExistingProjectionsLoading: boolean;
} {
  const {
    data,
    isLoading,
    isError: isSimulationExistingProjectionsError,
    isFetching
  } = useGetExistingProjectionsQuery({
    allMarkets,
    gameId,
    leagueId
  });

  const { existingProjections = [] } = data ?? {};

  const isSimulationExistingProjectionsLoading = isLoading || isFetching;

  return {
    existingProjections,
    isSimulationExistingProjectionsError,
    isSimulationExistingProjectionsLoading
  };
}
